import React from "react";
import { SectionHeader } from "./SectionHeader";

export const SectionHeaderExample = () => {
  return <SectionHeader header="Title" subcopy="This is subcopy" />;
};
